export const site = {
  name: 'Mustafa Gürses',
  asciiName: 'Mustafa Gurses',
  shortName: 'MG',
  title: 'Full Stack Developer',
  url: 'https://mustafagurses.com',
  location: 'Gaziantep, Türkiye',
  timezone: 'Europe/Istanbul',
  email: 'gursesmm@gmail.com',
  availability: 'Yeni işbirliklerine açık',
  tagline: 'İşletmenin omurgasını yazan geliştirici.',
  manifesto:
    'ERP ve MRP sistemlerinden e-ticaret, B2B ve yayınlı mobil uygulamalara kadar ürünü uçtan uca kuruyorum: mimari, veri, arayüz ve canlıya alma.',
  social: [
    { label: 'GitHub', href: 'https://github.com/mustafagurses' },
    { label: 'LinkedIn', href: 'https://linkedin.com/in/mustafagurses' },
  ],
  stores: [
    {
      label: 'Play Store',
      href: 'https://play.google.com/store/apps/dev?id=4634110951618336248',
    },
    {
      label: 'App Store',
      href: 'https://apps.apple.com/tr/developer/mustafa-gurses/id6781404875?l=tr',
    },
  ],
} as const;

export const nav = [
  { to: '/about', label: 'Hakkımda' },
  { to: '/projects', label: 'İşler' },
] as const;

export const stats = [
  { value: '9+', label: 'Yıl deneyim' },
  { value: '30+', label: 'Teslim edilen iş' },
  { value: 'ERP', label: 'Ana uzmanlık' },
  { value: 'Uçtan uca', label: 'Ürün yaklaşımı' },
] as const;

export const capabilities = [
  {
    index: '01',
    title: 'ERP & MRP',
    text: 'Stok, üretim, finans ve insan kaynakları süreçlerini tek omurgada toplayan kurumsal sistemler. Analizden canlıya almaya kadar.',
  },
  {
    index: '02',
    title: 'Full stack ürün',
    text: 'React / Next.js arayüz, .NET veya Node.js servisler, SQL veri modeli. Admin, müşteri yüzü ve API aynı elde.',
  },
  {
    index: '03',
    title: 'Entegrasyon',
    text: 'Netsis ve benzeri ERP’lerle konuşan B2B, ödeme, stok ve sipariş hatları. Gerçek iş verisinin aktığı yer.',
  },
  {
    index: '04',
    title: 'Mobil & saha',
    text: 'Flutter, React Native ve Android ile sahadaki kullanıcıya inen uygulamalar. Play Store ve App Store’da yayınlı ürünler dahil.',
  },
] as const;

export type ProjectCategory = 'kurumsal' | 'eticaret' | 'urun' | 'b2b' | 'mobil';
export type ProjectStore = 'play' | 'appstore';

export type Project = {
  id: string;
  title: string;
  year: string;
  category: ProjectCategory;
  tags: string[];
  summary: string;
  story: string;
  role: string;
  tech: string[];
  href: string;
  image: string;
  store?: ProjectStore;
  featured?: boolean;
};

export const projectFilters: { id: 'all' | ProjectCategory; label: string }[] = [
  { id: 'all', label: 'Tümü' },
  { id: 'mobil', label: 'Mobil' },
  { id: 'kurumsal', label: 'Kurumsal' },
  { id: 'eticaret', label: 'E-ticaret' },
  { id: 'b2b', label: 'B2B' },
  { id: 'urun', label: 'Ürün' },
];

export const projects: Project[] = [
  {
    id: 'erpen-b2b',
    title: 'Erpen B2B',
    year: '2026',
    category: 'b2b',
    tags: ['B2B', 'Bayi', 'ERP'],
    summary: 'Bayilere özel sipariş, stok ve cari hesap paneli. Canlıda: b2b.erpen.com.tr',
    story:
      'Erpen’in PVC kapı-pencere bayi ağı için yazdığım B2B portal. Bayi giriş yapar; stok, sipariş ve cari hesabı tek kurumsal panelden, gerçek zamanlı yönetir. Ölçü ve adetle hızlı sipariş, 7/24 erişim, şifreli oturum.',
    role: 'Full stack geliştirme',
    tech: ['.NET', 'SQL Server', 'B2B', 'ERP'],
    href: 'https://b2b.erpen.com.tr',
    image: '/projects/erpen-b2b.jpg',
    featured: true,
  },
  {
    id: 'ehliyet-prime',
    title: 'Ehliyet Prime',
    year: '2026',
    category: 'mobil',
    tags: ['Play Store', 'Eğitim'],
    summary: 'Ehliyet sınavına hazırlık: müfredata uygun deneme, sınav simülasyonu ve istatistik.',
    story:
      'Aegiron Software adıyla Google Play’de yayınlanan eğitim uygulaması. 2021–2026 müfredatına uygun kategorik testler, süre sınırlı sınav modu, doğru/yanlış analizi ve motivasyon rozetleri. Misafir veya Google ile giriş; resmi kurum bağlantısı yok, tamamen alıştırma amaçlı.',
    role: 'Mobil ürün · yayıncı',
    tech: ['Android', 'Play Store', 'Eğitim'],
    href: 'https://play.google.com/store/apps/details?id=com.aegironsoftware.ehliyetprime',
    image: '/projects/ehliyet-prime.jpg',
    store: 'play',
    featured: true,
  },
  {
    id: 'werkplan',
    title: 'WerkPlan',
    year: '2026',
    category: 'mobil',
    tags: ['App Store', 'İş'],
    summary: 'Çok şubeli ekipler için vardiya, puantaj ve görev uygulaması. App Store’da yayında.',
    story:
      'Apple App Store’da yayınlanan WerkPlan; personelin giriş-çıkış ve mola basması, yöneticinin canlı dashboard, şube ve saat takibi yapması için yazıldı. Görev atama, geçmiş düzeltme, push bildirim. Perakende, gastronomi ve saha ekipleri için. iOS 15.6+',
    role: 'Mobil ürün · yayıncı',
    tech: ['iOS', 'App Store'],
    href: 'https://apps.apple.com/tr/app/werkplan/id6781404873?l=tr',
    image: '/projects/werkplan.jpg',
    store: 'appstore',
    featured: true,
  },
  {
    id: 'hr-point',
    title: 'HR Point',
    year: '2025',
    category: 'urun',
    tags: ['İnsan kaynakları', 'Multi-tenant'],
    summary: 'Çok kiracılı insan kaynakları platformu: landing, admin ve REST API aynı üründe.',
    story:
      'Personel, izin ve kurumsal yönetim ihtiyaçlarını tek yerde toplayan bir İK ürünü. Multi-tenant yapı, Prisma ile PostgreSQL, Docker ile dağıtım. Hem satış yüzü hem operasyon paneli yazıldı.',
    role: 'Full stack geliştirme',
    tech: ['Next.js', 'NestJS', 'PostgreSQL', 'Prisma', 'Docker'],
    href: 'https://hrpoint.com.tr',
    image: '/projects/hr-point.jpg',
    featured: true,
  },
  {
    id: 'zenzer',
    title: 'Zenzer',
    year: '2025',
    category: 'eticaret',
    tags: ['E-ticaret', 'Arama'],
    summary: 'Admin, vitrin ve backend’i ayrı duran, arama katmanlı kapsamlı e-ticaret.',
    story:
      'Katalog, sepet, ödeme ve yönetim paneli uçtan uca kuruldu. React / Next.js vitrin, PostgreSQL veri katmanı, Elasticsearch ile ürün arama. Operasyonun günlük kullandığı admin ayrı bir yüzey.',
    role: 'Full stack geliştirme',
    tech: ['React', 'Next.js', 'PostgreSQL', 'Docker', 'Elasticsearch'],
    href: 'https://zenzer.com.tr',
    image: '/projects/zenzer.jpg',
  },
  {
    id: 'haliser',
    title: 'Halıser B2B',
    year: '2024',
    category: 'b2b',
    tags: ['B2B', 'ERP entegrasyonu'],
    summary: 'Netsis ERP ile konuşan kurumsal B2B sipariş ve bayi kanalı.',
    story:
      'Bayilerin stok ve siparişi ERP’den kopmadan görmesi gerekiyordu. .NET Core servisler MSSQL üzerinden Netsis verisine bağlandı; bayi yüzü sade, operasyonel ve hızlı tutuldu.',
    role: 'Backend ve entegrasyon',
    tech: ['.NET Core', 'MSSQL', 'JavaScript', 'REST API'],
    href: 'https://b2b.befani.com.tr/',
    image: '/projects/haliser.jpg',
  },
  {
    id: 'star-iplik',
    title: 'Star İplik',
    year: '2024',
    category: 'kurumsal',
    tags: ['Kurumsal web', 'Üretim'],
    summary: 'İplik fabrikası için profil, katalog ve iletişim omurgası.',
    story:
      'Üretici firmanın kendini net anlatması, ürün gruplarını göstermesi ve müşteri talebini toplaması gerekiyordu. ASP.NET Core MVC ve SQL Server ile sade, bakımı kolay bir kurumsal site kuruldu.',
    role: 'Web ve backend',
    tech: ['ASP.NET Core', 'MVC', 'C#', 'SQL Server'],
    href: 'https://www.stariplik.com',
    image: '/projects/star-iplik.jpg',
  },
  {
    id: 'rahimoglu',
    title: 'Rahimoğlu',
    year: '2024',
    category: 'eticaret',
    tags: ['E-ticaret', 'Çoklu dil'],
    summary: 'Yerli mahsul ve kuru yemiş ticareti için çok dilli satış yüzü.',
    story:
      'Hem yerel hem ihracat müşterisine hitap eden bir vitrin. Next.js ile web, React Native ile mobil düşünülerek i18n ve katalog yönetimi kuruldu.',
    role: 'Frontend ve ürün yüzü',
    tech: ['React Native', 'Next.js', 'MongoDB', 'i18n'],
    href: 'https://www.rahimoglu.com',
    image: '/projects/rahimoglu.jpg',
  },
  {
    id: 'bahar',
    title: 'Bahar Hair Transplant',
    year: '2024',
    category: 'kurumsal',
    tags: ['Sağlık', 'Uluslararası'],
    summary: 'Saç ekim kliniği için tanıtım, hizmet ve randevu hattı.',
    story:
      'Uluslararası hasta adayının kliniği anlaması, hizmeti görmesi ve iletişime geçmesi için sade bir danışmanlık yüzü. Next.js ve Firebase ile içerik ve form akışı kuruldu.',
    role: 'Web ürünü',
    tech: ['React Native', 'Next.js', 'Firebase', 'Tailwind CSS'],
    href: 'https://www.baharhairtransplant.com',
    image: '/projects/bahar.jpg',
  },
  {
    id: 'docsgate',
    title: 'DocsGate',
    year: '2023',
    category: 'urun',
    tags: ['Doküman', 'Kurumsal'],
    summary: 'Arşiv, sürüm ve ekip paylaşımı olan kurumsal doküman platformu.',
    story:
      'Dosyaların kaybolmadan durması, sürümlerin izlenmesi ve ekiplerin aynı arşivde çalışması için tasarlandı. Next.js arayüz, MSSQL veri katmanı.',
    role: 'Full stack geliştirme',
    tech: ['React Native', 'Next.js', 'MSSQL Server'],
    href: 'https://www.docsgate.com',
    image: '/projects/docsgate.jpg',
  },
];

export const process = [
  { title: 'Keşif', text: 'İş sürecini, kullanıcıyı ve mevcut sistemi dinlerim. Ne yazılacağını değil, neyin gerçekten çözüleceğini netleştiririm.' },
  { title: 'Mimari', text: 'Veri modeli, entegrasyon noktaları ve ekranlar aynı anda düşünülür. ERP işlerinde bu adım atlanırsa ürün yolda kırılır.' },
  { title: 'Geliştirme', text: 'Çalışan dilimleri erken gösteririm. Admin, API ve vitrin paralel ilerler; sürpriz büyük teslim olmaz.' },
  { title: 'Canlı', text: 'Dağıtım, izleme ve devir. Sistem sahada duruyorsa iş bitmiş sayılır.' },
] as const;

export const about = {
  lead: 'Mustafa Gürses — kurumsal yazılım ve dijital ürün geliştiricisi.',
  dek: 'Gaziantep merkezli çalışıyor; ERP, MRP, B2B ve mobil uygulamaları analizden canlıya almaya kadar uçtan uca teslim ediyorum.',
  p1: 'CEM Teknoloji bünyesinde Assistant Project Manager olarak Eruslu Global başta olmak üzere büyük ölçekli şirketlerin ERP, MRP ve iç yazılım projelerinin geliştirilmesinden, kontrolünden ve canlıya alınmasından sorumluyum. Unvanım proje yönetimi olmakla birlikte mimari tasarım, yazılım geliştirme ve sistem entegrasyonu süreçlerinde doğrudan yer alıyorum.',
  quote: 'Bir projenin tamamlanması, kodun yazılması değil; sistemin üretim ortamında güvenilir biçimde çalışmasıdır.',
  p2: 'Kariyerime freelance yazılım geliştirme ile başladım. Ardından kurumsal kaynak planlama sistemleri, İHA görüntü işleme ve Deneyap Türkiye’de mobil uygulama eğitmenliği geldi. Masaüstü, web ve mobil katmanlarda edindiğim deneyimi bugün özellikle .NET, React, Node.js ve SQL üzerinde yoğunlaştırıyorum. Play Store’da Aegiron Software, App Store’da kendi adıma yayınlanmış uygulamalarım bulunmaktadır.',
  p3: 'Çalışma yaklaşımım nettir: kapsamı belirsiz sunumlar değil, ölçülebilir ve sürdürülebilir sistemler. Stok, sipariş, insan kaynakları veya saha operasyonu fark etmeksizin hedefim, işletmenin günlük işini taşıyan yazılımlar üretmektir. İş birliği için iletişime geçebilirsiniz.',
};

export const experience = [
  {
    period: '2023 — Günümüz',
    role: 'Assistant Project Manager',
    org: 'CEM Teknoloji',
    points: [
      'Eruslu Global dahil büyük ölçekli şirketler için ERP, MRP ve iç projelerin geliştirilmesi, kontrolü ve yürütülmesi',
      'Süreçlerin dijitalleşmesi, sistem analizi ve canlıya alma koordinasyonu',
      'Teknik rehberlik ve proje ekiplerinin yönetimi',
    ],
    tech: ['C#', 'ASP.NET MVC', '.NET Core', 'LINQ', 'ADO.NET'],
  },
  {
    period: '2024 · 2 ay',
    role: 'Jüri',
    org: 'T3 Vakfı',
    points: ['Deneyap sınavlarında öğrenci teknoloji projelerini değerlendirme ve geri bildirim'],
    tech: [],
  },
  {
    period: '2022 — 2023',
    role: 'Software Developer',
    org: 'Mert Bilgisayar Sistemleri',
    points: [
      'Kurumsal kaynak planlama sistemleri',
      'Veritabanı tasarımı ve iş süreci analizi',
    ],
    tech: ['C#', 'SQL', 'T-SQL'],
  },
  {
    period: '2022 — 2023',
    role: 'Mobil uygulama eğitmeni',
    org: 'Deneyap Türkiye',
    points: ['Lise öğrencilerine Flutter ve mobil proje rehberliği'],
    tech: ['Flutter', 'Android'],
  },
  {
    period: '2021 · 6 ay',
    role: 'Machine Learning Specialist',
    org: 'AZURE Aviation & Aerospace',
    points: ['İHA için görüntü işleme ve hedef takibi'],
    tech: ['Python', 'Image Processing', 'Machine Learning'],
  },
  {
    period: '2014 — 2021',
    role: 'Freelance Developer',
    org: 'Freelancer.com',
    points: [
      'Web, masaüstü ve mobil ürün geliştirme',
      'Veritabanı tasarımı, Unity ile oyun projeleri',
    ],
    tech: ['C#', '.NET Core', 'React', 'Angular', 'Node.js', 'Java', 'Unity'],
  },
] as const;

export const education = [
  {
    years: '2017 — Devam',
    title: 'Yönetim Bilişim Sistemleri, Lisans',
    school: 'Anadolu Üniversitesi',
    text: 'Veri, işletme süreçleri ve bilgi sistemleri. Teknolojinin iş tarafına oturduğu yer.',
  },
  {
    years: '2013 — 2015',
    title: 'Bilgisayar Programlama, Önlisans',
    school: 'Mersin Üniversitesi',
    text: 'Programlama, veri yapıları, web ve veritabanı. Mesleğin temeli burada atıldı.',
  },
] as const;

export const skillGroups = [
  {
    title: 'Diller & runtime',
    items: ['C#', 'TypeScript', 'JavaScript', 'Java', 'Kotlin', 'Python', 'SQL / T-SQL'],
  },
  {
    title: 'Frontend',
    items: ['React', 'Next.js', 'Angular', 'jQuery', 'Flutter'],
  },
  {
    title: 'Backend',
    items: ['ASP.NET MVC', '.NET Core', 'Node.js', 'NestJS', 'REST API', 'ADO.NET', 'LINQ'],
  },
  {
    title: 'Veri',
    items: ['SQL Server', 'PostgreSQL', 'Oracle', 'MongoDB', 'Elasticsearch', 'Prisma'],
  },
  {
    title: 'Sistem',
    items: ['Git', 'Docker', 'Linux', 'Windows Server'],
  },
] as const;

export const certificates = [
  { title: 'Deneyap Türkiye Eğitmenlik', org: 'T3 Vakfı', date: 'Ağu 2022', note: 'Flutter' },
  { title: 'Angular ile Web Programcılığı', org: 'BTK Akademi', date: 'Şub 2022', note: '' },
  { title: 'Kotlin ile Android — İleri', org: 'BTK Akademi', date: 'Şub 2022', note: '' },
  { title: 'İleri Seviye Java', org: 'BTK Akademi', date: 'Şub 2022', note: '' },
  { title: 'Teknofest İHA Yarışması', org: 'T3 Vakfı', date: 'Eyl 2021', note: 'Python, görüntü işleme' },
  { title: 'Liderlik ve İşletme Yöneticiliği', org: 'İstanbul İşletme Enstitüsü', date: 'Nis 2018', note: '' },
  { title: 'Performans Değerlendirme (360)', org: 'İstanbul İşletme Enstitüsü', date: 'Nis 2018', note: '' },
  { title: 'Bordro Uygulamaları', org: 'İstanbul İşletme Enstitüsü', date: 'Mar 2018', note: '' },
] as const;

export const pageTitles: Record<string, string> = {
  '/': 'Mustafa Gürses | Yazılımcı, Full Stack Developer — Gaziantep',
  '/projects': 'Mustafa Gürses Projeleri | Yazılımcı İşleri',
  '/about': 'Mustafa Gürses Kimdir? | Yazılımcı Hakkında',
  '/contact': 'Mustafa Gürses İletişim | Yazılımcı',
};

export const pageDescriptions: Record<string, string> = {
  '/':
    'Mustafa Gürses (Mustafa Gurses) — Gaziantep merkezli yazılımcı ve full stack developer. ERP, MRP, B2B ve mobil uygulama geliştirme. CEM Teknoloji.',
  '/projects':
    'Mustafa Gürses yazılımcı portfolyosu: Erpen B2B, Ehliyet Prime, WerkPlan, HR Point ve canlı web projeleri.',
  '/about':
    'Mustafa Gürses kimdir? Gaziantep’te yaşayan full stack yazılımcı. CEM Teknoloji bünyesinde Eruslu Global ve büyük ölçekli şirketler için ERP, MRP ve dijital ürün geliştirir.',
  '/contact':
    'Mustafa Gürses ile iletişime geçin. Yazılımcı, full stack developer — Gaziantep. E-posta: gursesmm@gmail.com',
};

export const aboutFaqs = [
  {
    q: 'Mustafa Gürses kimdir?',
    a: 'Mustafa Gürses (Mustafa Gurses), Gaziantep merkezli full stack yazılımcıdır. CEM Teknoloji bünyesinde Eruslu Global başta olmak üzere büyük ölçekli şirketler için ERP, MRP, B2B ve mobil uygulamalar geliştirir.',
  },
  {
    q: 'Mustafa Gürses ne iş yapar?',
    a: 'Kurumsal yazılım, ERP, MRP, B2B sipariş sistemleri, e-ticaret ve yayınlı mobil uygulamalar geliştirir. Analizden canlıya almaya kadar uçtan uca teslim eder.',
  },
  {
    q: 'Mustafa Gürses nerede çalışıyor?',
    a: 'Gaziantep, Türkiye. CEM Teknoloji bünyesinde Assistant Project Manager olarak görev yapar; işler Türkiye genelinde ve uygulama mağazalarında yayınlanır.',
  },
];
